import axios from "axios";

export const getAuthCheck = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API}/Auth/check`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
